import * as Sentry from "@sentry/react-native";
import * as BackgroundTask from "expo-background-task";
import * as TaskManager from "expo-task-manager";
import { Platform } from "react-native";

import { prefetchExpoUpdateAsync } from "./prefetchExpoUpdateAsync";

export const BACKGROUND_EXPO_UPDATE_TASK_NAME =
  "whoosh-background-expo-update-prefetch";

export const BACKGROUND_EXPO_UPDATE_MINIMUM_INTERVAL_MINUTES = 12 * 60;

export const backgroundExpoUpdateTaskExecutor = async () => {
  try {
    await prefetchExpoUpdateAsync();

    return BackgroundTask.BackgroundTaskResult.Success;
  } catch (error) {
    Sentry.captureException(error);

    return BackgroundTask.BackgroundTaskResult.Failed;
  }
};

const defineBackgroundExpoUpdateTask = () => {
  if (
    Platform.OS === "web" ||
    TaskManager.isTaskDefined(BACKGROUND_EXPO_UPDATE_TASK_NAME)
  ) {
    return;
  }

  TaskManager.defineTask(
    BACKGROUND_EXPO_UPDATE_TASK_NAME,
    backgroundExpoUpdateTaskExecutor
  );
};

defineBackgroundExpoUpdateTask();

export const registerBackgroundExpoUpdateTaskAsync = async () => {
  if (Platform.OS === "web") {
    return;
  }

  try {
    const status = await BackgroundTask.getStatusAsync();

    if (status !== BackgroundTask.BackgroundTaskStatus.Available) {
      return;
    }

    const isRegistered = await TaskManager.isTaskRegisteredAsync(
      BACKGROUND_EXPO_UPDATE_TASK_NAME
    );

    if (isRegistered) {
      return;
    }

    await BackgroundTask.registerTaskAsync(BACKGROUND_EXPO_UPDATE_TASK_NAME, {
      minimumInterval: BACKGROUND_EXPO_UPDATE_MINIMUM_INTERVAL_MINUTES,
    });
  } catch (error) {
    Sentry.captureException(error);
  }
};
